import { connect } from "dvajs";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import styles from "./index.module.less";
import { Form, Input, Modal, Radio, Spin, message as toast, Tooltip } from "antd";
import IconFont from "@/components/icon";
import CheckSelect from "@/components/Work/BaseComponents/CheckSelect";
import { postFeedback } from "@/api/llm";
import { uniq } from "lodash";
const SUMMARY_REMARK_TIP_KEY = `SUMMARY_REMARK_TIP_KEY`;
import { LoadingOutlined } from "@/utils/antdIcon";
const aiScoreList = [
  {
    value: 5,
    label: "5分"
  },
  {
    value: 4,
    label: "4分"
  },
  {
    value: 3,
    label: "3分"
  },
  {
    value: 2,
    label: "2分"
  },
  {
    value: 1,
    label: "1分"
  }
];
function AiRemark(props: any) {
  const {
    message,
    currentEmployee,
    moduleType = "",
    onFeedback,
    question,
    style,
    modelWidth,
    llmTagsList
  } = props;
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [formData, setFormData] = useState<any>({});
  const [questionOptions, setQuestionOptions] = useState<any>([]);
  const [contentOptions, setContentOptions] = useState<any>([]);
  const [feedbackForm] = Form.useForm();

  const onModalCancel = useCallback(() => {
    setFormData({});
    if (feedbackForm) {
      feedbackForm.resetFields();
    }
    setModalVisible(false);
    setQuestionOptions(
      questionOptions.map((item: any) => {
        item.selected = false;
        return item;
      })
    );
    setContentOptions(
      contentOptions.map((item: any) => {
        item.selected = false;
        return item;
      })
    );
  }, [contentOptions, feedbackForm, questionOptions]);

  // 通用传参
  const commParams = useCallback(() => {
    return {
      appId: currentEmployee.app,
      userId: currentEmployee.userId,
      moduleType,
      requestId: message.id,
      modelContent: message.summary,
      question
    };
  }, [
    currentEmployee.app,
    currentEmployee.userId,
    message.id,
    message.summary,
    moduleType,
    question
  ]);

  // 提交反馈
  const onModalOk = useCallback(() => {
    if (!formData?.score) {
      toast.warn("请填写分数");
      return;
    }
    // 反馈
    const req = {
      ...formData,
      ...commParams()
    };
    postFeedback(req).finally(() => {
      onModalCancel();
      if (onFeedback) {
        onFeedback(req?.assess);
      }
      toast.success({
        key: SUMMARY_REMARK_TIP_KEY,
        content: "反馈成功"
      });
    });
  }, [formData, commParams, onModalCancel, onFeedback]);

  // 获取标签
  const getTags = useCallback(async () => {
    const { content_tags = [], question_tags = [] } = llmTagsList;
    setContentOptions(
      content_tags.map((item: any) => {
        return {
          ...item,
          text: item.tag
        };
      })
    );
    setQuestionOptions(
      question_tags.map((item: any) => {
        return {
          ...item,
          text: item.tag
        };
      })
    );
  }, [llmTagsList]);

  const handleFormDataChange = useCallback(
    (val, type) => {
      setFormData({
        ...formData,
        [type]: val
      });
    },
    [formData]
  );

  // 踩
  const handleCai = useCallback(() => {
    if (message?.assess === 0) {
      onFeedback("");
      return;
    }
    handleFormDataChange(0, "assess");
    setModalVisible(true);
  }, [handleFormDataChange, message?.assess, onFeedback]);

  // 赞
  const handleZan = useCallback(() => {
    // 取消
    if (message?.assess === 1) {
      onFeedback("");
      return;
    }
    const req = {
      assess: 1,
      ...commParams()
    };
    postFeedback(req).finally(() => {
      onModalCancel();
      if (onFeedback) {
        onFeedback(req?.assess);
      }
    });
  }, [commParams, message?.assess, onFeedback, onModalCancel]);

  const handleChecked = useCallback(
    (type, res) => {
      const { tagCodes = [] } = formData;
      const newCode = uniq([...tagCodes, ...res]);
      setFormData({
        ...formData,
        tagCodes: newCode
      });
    },
    [contentOptions, formData, questionOptions]
  );

  const isZan = useMemo(() => {
    return message?.assess && message?.assess === 1;
  }, [message?.assess]);

  const isCai = useMemo(() => {
    return message?.assess === 0;
  }, [message?.assess]);

  const antIcon = <LoadingOutlined style={{ fontSize: 30 }} spin />;
  const loadingComp = useMemo(() => {
    return (
      <div className={styles["loading"]}>
        <Spin indicator={antIcon} />
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getTags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className={styles["ai-remark-wrap"]} style={style}>
        <Tooltip title="点赞">
          <div className={`${styles["item-btn"]} ${isZan ? styles["done"] : ""}`}>
            <IconFont
              type={isZan ? "iconzan2" : "iconzan1"}
              className={styles["icon"]}
              onClick={handleZan}
            />
          </div>
        </Tooltip>
        <Tooltip title="点踩">
          <div
            className={`${styles["item-btn"]} ${isCai ? styles["done"] : ""}`}
            onClick={handleCai}
          >
            <IconFont type={isCai ? "iconcai2" : "iconcai1"} className={styles["icon"]} />
          </div>
        </Tooltip>
      </div>
      <Modal
        className={styles["ai-remark-modal"]}
        visible={modalVisible}
        zIndex={2000}
        title="期待您的进一步反馈"
        onCancel={onModalCancel}
        onOk={onModalOk}
        okText="确定"
        cancelText="取消"
        width={modelWidth || 512}
        centered
      >
        <Form layout="vertical" autoComplete="off" form={feedbackForm}>
          <Form.Item name="score" label="总体评分" required>
            <Radio.Group
              onChange={(e) => handleFormDataChange(e?.target?.value, "score")}
              value={formData?.score}
            >
              {aiScoreList.map((r: any) => (
                <Radio key={r.value} value={r.value}>
                  {r.label}
                </Radio>
              ))}
            </Radio.Group>
          </Form.Item>
          <Form.Item label="针对用户问题（可多选）">
            {!questionOptions?.length ? (
              loadingComp
            ) : (
              <CheckSelect
                options={questionOptions}
                type="checkbox"
                onCheckboxChange={(e) => handleChecked("question", e)}
              />
            )}
          </Form.Item>
          <Form.Item label="针对回复回答（可多选）" className={styles["no-margin"]}>
            {!contentOptions?.length ? (
              loadingComp
            ) : (
              <CheckSelect
                options={contentOptions}
                type="checkbox"
                onCheckboxChange={(e) => handleChecked("question", e)}
              />
            )}
          </Form.Item>
          <Form.Item name="comment" className={styles["no-margin"]}>
            <Input.TextArea
              placeholder="请告诉我您的建议或理想答案是什么？"
              maxLength={500}
              autoSize={{ minRows: 4 }}
              onChange={(e) => handleFormDataChange(e?.target?.value, "comment")}
            />
            <p className="count">
              <span>{formData?.comment?.length || 0}</span>
              /500
            </p>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

function mapStateToProps({ chat }: any) {
  return {
    currentEmployee: chat.currentEmployee,
    llmTagsList: chat.llmTagsList
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(AiRemark);
